export enum DenialReasonEnum {
    None = 0,
    FraudOrFalsifiedDocument = 1,
    FailedCompliance = 2,
    NotEligibleForOnboarding = 3,
    ExceededReuploadAttempts = 4,
    Other = 5,
}

export const DENIAL_REASON_OPTIONS: { label: string; value: DenialReasonEnum }[] = [
    { label: 'Fraud / Falsified Document', value: DenialReasonEnum.FraudOrFalsifiedDocument },
    { label: 'Failed Compliance Verification', value: DenialReasonEnum.FailedCompliance },
    { label: 'Not Eligible for Onboarding', value: DenialReasonEnum.NotEligibleForOnboarding },
    { label: 'Exceeded Maximum Reupload Attempts', value: DenialReasonEnum.ExceededReuploadAttempts },
    { label: 'Other', value: DenialReasonEnum.Other },
];
